import jwtAxios from '@tenant/services/auth/jwt-auth';

export const APP_INSTANCE_APIS = {
  ROOT: 'api/app-instances',
  IDP_CLIENTS: 'api/app-instances/:appInstanceId/idp-clients',
};

const replaceEndpointUrl = (
  appInstanceId,
  endpoint = APP_INSTANCE_APIS.IDP_CLIENTS,
) => {
  return endpoint.replace(':appInstanceId', appInstanceId);
};

export const getListAppInstanceQuery = (params) => {
  return jwtAxios.get(APP_INSTANCE_APIS.ROOT, { params });
};

export const getListAppInstanceQueryWithAssocicated = (params) => {
  return jwtAxios.get(`${APP_INSTANCE_APIS.ROOT}/associcated-apps`, { params });
}

export const getDetailAppInstanceQuery = (id) => {
  return jwtAxios.get(APP_INSTANCE_APIS.ROOT + '/' + id);
};

export const addAppInstanceQuery = (payload) => {
  return jwtAxios.post(APP_INSTANCE_APIS.ROOT, payload);
};

// Package-free create path: no AppPackageId, containers are defined inline.
export const addAppInstanceInlineQuery = (payload) => {
  return jwtAxios.post(`${APP_INSTANCE_APIS.ROOT}/inline`, payload);
};

// Add (or re-add) a single container to a package-free (inline) instance.
export const addContainerToInstanceQuery = ({ appInstanceId, payload }) => {
  return jwtAxios.post(
    `${APP_INSTANCE_APIS.ROOT}/${appInstanceId}/container-apps/inline`,
    payload,
  );
};

export const deleteAppInstanceQuery = (payload) => {
  return jwtAxios.delete(APP_INSTANCE_APIS.ROOT + '/' + payload?.Id);
};

export const getListClientsByAppInstance = (appInstanceId) => {
  return jwtAxios.get(replaceEndpointUrl(appInstanceId));
};

export const addClientsByAppInstance = ({ appInstanceId, ...payload }) => {
  return jwtAxios.post(replaceEndpointUrl(appInstanceId), payload);
};

export const updateClientsByAppInstance = ({
  appInstanceId,
  idpClientId,
  ...payload
}) => {
  return jwtAxios.patch(
    replaceEndpointUrl(appInstanceId) + '/' + idpClientId,
    payload,
  );
};

export const deleteClientsByAppInstance = ({ appInstanceId, idpClientId }) => {
  return jwtAxios.delete(replaceEndpointUrl(appInstanceId) + '/' + idpClientId);
};

export const updateMappingsAPI = (payload) => {
  return jwtAxios.post(
    APP_INSTANCE_APIS.ROOT + '/' + payload.appInstanceId + '/mappings/update',
    payload?.marketplaceApps,
  );
};
